import React from 'react';
import { useOfertaCard } from '../../../context/ofertas-card-context';
import { CarlineWithOfertas } from '../../../services/ofertas-service/models/ofertas';
import { OfertaCardDesktopAnimated } from './oferta-card-desktop-animated';
import { CardsContainerDesktop } from './ui/cards-container-desktop';

export const OfertaCardsContainerDesktop = React.forwardRef<
	HTMLDivElement,
	{
		carline: CarlineWithOfertas;
		className: string;
	}
>(({ carline }, ref) => {
	const { hasOneCarline } = useOfertaCard();

	return (
		<CardsContainerDesktop hasOneCarline={hasOneCarline} className="ofertas-cards-container-desktop" ref={ref}>
			{carline.ofertas.map((oferta) => (
				<OfertaCardDesktopAnimated
					className={`oferta-card-desktop-${oferta.id}`}
					carline={carline}
					currentOferta={oferta}
					ofertasNumber={carline.ofertas.length}
				/>
			))}
		</CardsContainerDesktop>
	);
});
